function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-c9b5995e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=1udq9m5yalv!../../../node_modules/string-replace-webpack-plugin/loader.js?id=5v3roo83miv!./Header.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=1udq9m5yalv!../../../node_modules/string-replace-webpack-plugin/loader.js?id=5v3roo83miv!./Header.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-c9b5995e\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=1udq9m5yalv!../../../node_modules/string-replace-webpack-plugin/loader.js?id=5v3roo83miv!./Header.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c9b5995e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/leaf-relief/Header.vue
// module id = 668
// module chunks = 0